import { render } from "./UsersFilterInventory.vue?vue&type=template&id=0c090c51&scoped=true"
import script from "./UsersFilterInventory.vue?vue&type=script&lang=js"
export * from "./UsersFilterInventory.vue?vue&type=script&lang=js"

import "./UsersFilterInventory.vue?vue&type=style&index=0&id=0c090c51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c090c51"]])

export default __exports__